import React, { useEffect, useState } from "react";
import {
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CircularProgress,
    Box,
    Button,
    MenuItem,
    TextField,
    Checkbox,
    Switch,
    InputAdornment,
    Tooltip,
    IconButton
} from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { ArrowBack } from "@mui/icons-material";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { getAuthData } from "../../utils/auth";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";

const PlanesProductos = () => {
    const [planes, setPlanes] = useState([]);
    const [productosImg, setProductosImg] = useState(null);
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [currentPlan, setCurrentPlan] = useState(null);
    const [formData, setFormData] = useState({
        tipo_servicio: "",
        descripcion: "",
        puestos: 0,
        capilla: "",
        lado: "",
        tipo_nicho: "",
        fila_rango: "",
        de_contado_bcv: 0,
        de_contado: 0,
        financiado: 0,
        cuota_1: 0,
        cuota_2: 0,
        cuota_3: 0,
        cuota_4: 0,
        cuota_5: 0,
    });
    const [enabledCuotas, setEnabledCuotas] = useState({
        cuota_1: true, // 3 cuotas
        cuota_2: true, // 6 cuotas
        cuota_3: true, // 9 cuotas
        cuota_4: true, // 12 cuotas
        cuota_5: true, // 18 cuotas
    });

    const authData = getAuthData();
    const token = authData?.token;

    useEffect(() => {
        fetchPlanes();
    }, []);

    const fetchPlanes = async () => {
        try {
            const config = token
                ? { headers: { Authorization: `Bearer ${token}` } }
                : {};
            const response = await axios.get(`${apiUrl}/api/v1/admin/planes/productos`, config);
            setPlanes(response.data);
        } catch (error) {
            console.error("Error cargando planes:", error);
            toast.error("Error al cargar los planes");
        } finally {
            setLoading(false);
        }
    };

    const handleOpenModal = (plan = null) => {
        if (plan) {
            setCurrentPlan(plan);
            setFormData({
                tipo_servicio: plan.tipo_servicio || "",
                descripcion: plan.descripcion,
                capilla: plan.capilla || "",
                lado: plan.lado || "",
                tipo_nicho: plan.tipo_nicho || "",
                fila_rango: plan.fila_rango || "",
                puestos: plan.puestos,
                de_contado_bcv: plan.de_contado_bcv,
                de_contado: plan.de_contado,
                financiado: plan.financiado,
                cuota_1: plan.cuota_1 || 0,
                cuota_2: plan.cuota_2 || 0,
                cuota_3: plan.cuota_3 || 0,
                cuota_4: plan.cuota_4 || 0,
                cuota_5: plan.cuota_5 || 0,
            });
            setEnabledCuotas({
                cuota_1: plan.cuota_1 !== null && plan.cuota_1 !== 0,
                cuota_2: plan.cuota_2 !== null && plan.cuota_2 !== 0,
                cuota_3: plan.cuota_3 !== null && plan.cuota_3 !== 0,
                cuota_4: plan.cuota_4 !== null && plan.cuota_4 !== 0,
                cuota_5: plan.cuota_5 !== null && plan.cuota_5 !== 0,
            });
        } else {
            setCurrentPlan(null);
            setFormData({
                tipo_servicio: "",
                descripcion: "",
                puestos: 0,
                de_contado_bcv: 0,
                de_contado: 0,
                financiado: 0,
                cuota_1: 0,
                cuota_2: 0,
                cuota_3: 0,
                cuota_4: 0,
                cuota_5: 0,
            });
            setEnabledCuotas({
                cuota_1: true,
                cuota_2: true,
                cuota_3: true,
                cuota_4: true,
                cuota_5: true,
            });
        }
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleFileChange = (event, setFileType) => {
        const file = event.target.files[0];
        if (file) {
            if (
                (setFileType === setProductosImg && file.type !== "application/pdf") ||
                (setFileType === setFile && file.type !== "text/csv")
            ) {
                toast.info(
                    `Por favor, selecciona un archivo ${setFileType === setProductosImg ? "PDF" : "CSV"
                    } válido.`
                );
                return;
            }
            setFileType(file);
        } else {
            toast.info("Por favor, selecciona un archivo válido.");
        }
    };

    const handleUpload = async () => {

        const formDataCsv = new FormData();
        formDataCsv.append("file", file);

        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            };

            // Enviar CSV al endpoint /api/admin/upload-parcelas
            await axios.post(
                `${apiUrl}/api/admin/upload-plan`,
                formDataCsv,
                config
            );

            toast.success("Planes guardados exitosamente.");
            setFile(null);
        } catch (error) {
            console.error("Error al subir los archivos:", error);
            alert("Error al actualizar las parcelas.");
        }
    };

    const handleUploadImage = async () => {
        if (!productosImg) return;
        const formData = new FormData();
        formData.append("file", productosImg);
        formData.append("tipo", "productos");

        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            };
            await axios.post(`${apiUrl}/api/upload/planes`, formData, config);
            toast.success("Documento de productos subido exitosamente.");
            setProductosImg(null);
        } catch (error) {
            console.error("Error al subir el documento:", error);
            toast.error("Error al subir el documento.");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => {
            const newData = { ...prev, [name]: value };

            if (name === "de_contado") {
                const precio = parseFloat(value) || 0;

                if (precio > 0) {
                    newData.cuota_1 = (precio * 1.05).toFixed(2); // 3 cuotas
                    newData.cuota_2 = (precio * 1.10).toFixed(2); // 6 cuotas
                    newData.cuota_3 = (precio * 1.15).toFixed(2); // 9 cuotas
                    newData.cuota_4 = (precio * 1.20).toFixed(2); // 12 cuotas
                    newData.cuota_5 = (precio * 1.30).toFixed(2); // 18 cuotas
                } else {
                    newData.cuota_1 = "0.00";
                    newData.cuota_2 = "0.00";
                    newData.cuota_3 = "0.00";
                    newData.cuota_4 = "0.00";
                    newData.cuota_5 = "0.00";
                }
            }
            return newData;
        });
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setEnabledCuotas((prev) => ({ ...prev, [name]: checked }));
    };

    const handleSubmit = async () => {
        try {
            const config = token
                ? { headers: { Authorization: `Bearer ${token}` } }
                : {};

            // Prepare payload
            const payload = { ...formData };
            // Set disabled cuotas to null or 0 if preferred
            if (!enabledCuotas.cuota_1) payload.cuota_1 = null;
            if (!enabledCuotas.cuota_2) payload.cuota_2 = null;
            if (!enabledCuotas.cuota_3) payload.cuota_3 = null;
            if (!enabledCuotas.cuota_4) payload.cuota_4 = null;
            if (!enabledCuotas.cuota_5) payload.cuota_5 = null;


            if (currentPlan) {
                await axios.put(`${apiUrl}/api/v1/admin/planes/productos/${currentPlan.id}`, payload, config);
                toast.success("Plan actualizado correctamente");
            } else {
                await axios.post(`${apiUrl}/api/v1/admin/planes/productos`, payload, config);
                toast.success("Plan creado correctamente");
            }
            fetchPlanes();
            handleCloseModal();
        } catch (error) {
            console.error("Error guardando plan:", error);
            toast.error("Error al guardar el plan");
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("¿Estás seguro de que quieres eliminar este plan?")) {
            try {
                const config = token
                    ? { headers: { Authorization: `Bearer ${token}` } }
                    : {};
                await axios.delete(`${apiUrl}/api/v1/admin/planes/productos/${id}`, config);
                toast.success("Plan eliminado correctamente");
                fetchPlanes();
            } catch (error) {
                console.error("Error eliminando plan:", error);
                toast.error("Error al eliminar el plan");
            }
        }
    };

    const handleToggleStatus = async (id, currentStatus) => {
        try {
            const config = token
                ? { headers: { Authorization: `Bearer ${token}` } }
                : {};

            await axios.patch(`${apiUrl}/api/v1/admin/planes/productos/${id}/estado`, { activo: !currentStatus }, config);

            setPlanes(planes.map(plan =>
                plan.id === id ? { ...plan, is_active: !currentStatus } : plan
            ));
            toast.success("Estado actualizado correctamente");
        } catch (error) {
            console.error("Error actualizando estado:", error);
            toast.error("Error al actualizar el estado");
        }
    };

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                margin: "0 auto",
                padding: 3,
                boxShadow: 3,
                backgroundColor: "#ffffff",
                borderRadius: 2,
            }}
        >

            <Typography
                variant="h6"
                sx={{ fontFamily: "Bakbak One, sans-serif", color: "#0A4575" }}
            >
                LISTA DE PRECIOS PAC - (PRODUCTOS)
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button variant="contained" component="label" color="primary">
                        Seleccionar Documento {productosImg ? `(${productosImg.name})` : ''}
                        <input
                            type="file"
                            hidden
                            accept="application/pdf"
                            onChange={(e) => handleFileChange(e, setProductosImg)}
                        />
                    </Button>
                    <Button 
                        variant="contained" 
                        color="success" 
                        disabled={!productosImg} 
                        onClick={handleUploadImage}
                    >
                        Subir
                    </Button>
                </Box>

                <Button variant="contained" color="primary" onClick={() => handleOpenModal()}>
                    Crear Nuevo Plan
                </Button>
            </Box>

            <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
                <Table sx={{ minWidth: "1200px", mt: 2 }}>
                    <TableHead sx={{ backgroundColor: "#0A4575" }}>
                        <TableRow>
                            <TableCell rowSpan={2} sx={{ color: "#fff", fontWeight: "bold" }}>PRODUCTOS</TableCell>
                            <TableCell colSpan={2} align="center" sx={{ color: "#fff", fontWeight: "bold" }}>CONTADO</TableCell>
                            <TableCell colSpan={5} align="center" sx={{ color: "#fff", fontWeight: "bold" }}>PLANES</TableCell>
                            <TableCell rowSpan={2} sx={{ color: "#fff", fontWeight: "bold" }}>ESTADO</TableCell>
                            <TableCell rowSpan={2} sx={{ color: "#fff", fontWeight: "bold" }}>ACCIONES</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold", fontSize: "0.8rem" }}>PRECIO CONTADO (BCV)</TableCell>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold", fontSize: "0.8rem" }}>PRECIO CONTADO ($)</TableCell>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold", fontSize: "0.8rem" }}>5% (3 CUOTAS)</TableCell>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold", fontSize: "0.8rem" }}>10% (6 CUOTAS)</TableCell>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold", fontSize: "0.8rem" }}>15% (9 CUOTAS)</TableCell>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold", fontSize: "0.8rem" }}>20% (12 CUOTAS)</TableCell>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold", fontSize: "0.8rem" }}>30% (18 CUOTAS)</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {planes.map((plan) => (
                            <TableRow key={plan.id} hover>
                                <TableCell>{plan.descripcion}</TableCell>
                                <TableCell>${Number(plan.de_contado_bcv).toFixed(2)}</TableCell>
                                <TableCell>${Number(plan.de_contado).toFixed(2)}</TableCell>
                                <TableCell>{plan.cuota_1 ? `$${Number(plan.cuota_1).toFixed(2)}` : "N/A"}</TableCell>
                                <TableCell>{plan.cuota_2 ? `$${Number(plan.cuota_2).toFixed(2)}` : "N/A"}</TableCell>
                                <TableCell>{plan.cuota_3 ? `$${Number(plan.cuota_3).toFixed(2)}` : "N/A"}</TableCell>
                                <TableCell>{plan.cuota_4 ? `$${Number(plan.cuota_4).toFixed(2)}` : "N/A"}</TableCell>
                                <TableCell>{plan.cuota_5 ? `$${Number(plan.cuota_5).toFixed(2)}` : "N/A"}</TableCell>
                                <TableCell>
                                    <Switch
                                        checked={plan.is_active}
                                        onChange={() => handleToggleStatus(plan.id, plan.is_active)}
                                        color="primary"
                                    />
                                </TableCell>
                                <TableCell>
                                    <Button size="small" onClick={() => handleOpenModal(plan)}>Editar</Button>
                                    <Button size="small" color="error" onClick={() => handleDelete(plan.id)}>Eliminar</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Button
                variant="contained"
                component={Link}
                to="/administracion"
                startIcon={<ArrowBack />}
                sx={{
                    marginTop: "15px",
                    backgroundColor: "#0A4575",
                    color: "#FFFFFF",
                    "&:hover": { backgroundColor: "#083a5e" },
                }}
            >
                Volver
            </Button>

            {/* Modal for Create/Edit */}
            {openModal && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center',
                    zIndex: 1000
                }}>
                    <Paper sx={{ padding: 4, width: '600px', maxHeight: '90vh', overflowY: 'auto' }}>
                        <Typography variant="h6" sx={{ fontFamily: "Bakbak One", color: "#0A4575", mb: 2 }}>
                            {currentPlan ? "Editar Plan" : "Crear Nuevo Plan"}
                        </Typography>
                        <TextField
                            select
                            fullWidth
                            margin="normal"
                            size="small"
                            label="Tipo de Plan"
                            value={formData.tipo_servicio}
                            onChange={(e) => {
                                const value = e.target.value;

                                setFormData(prev => ({
                                    ...prev,
                                    tipo_servicio: value,
                                    capilla: "",
                                    lado: "",
                                    tipo_nicho: "",
                                    fila_rango: "",
                                    puestos: 0
                                }));
                            }}
                            sx={{ boxShadow: 3 }}
                        >
                            <MenuItem value="parcela">Parcela</MenuItem>
                            <MenuItem value="nichos-columbarios">Nichos Columbarios</MenuItem>
                            <MenuItem value="nicho_ataud">Nicho Ataúd</MenuItem>
                        </TextField>
                        {formData.tipo_servicio === "parcela" && (
                            <>
                                <TextField
                                    fullWidth
                                    size="small"
                                    margin="normal"
                                    label="Nombre del Plan"
                                    name="descripcion"
                                    value={formData.descripcion}
                                    onChange={handleInputChange}
                                    sx={{ boxShadow: 3 }}
                                />

                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    margin="normal"
                                    label="Puestos"
                                    name="puestos"
                                    value={formData.puestos}
                                    onChange={handleInputChange}
                                    sx={{ boxShadow: 3 }}
                                >
                                    <MenuItem value={1}>1 Puesto</MenuItem>
                                    <MenuItem value={3}>3 Puestos</MenuItem>
                                </TextField>
                            </>
                        )}
                        {formData.tipo_servicio === "nichos-columbarios" && (
                            <>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    size="small"
                                    label="Nombre del Plan"
                                    name="descripcion"
                                    value={formData.descripcion || ""} onChange={handleInputChange}
                                    sx={{ boxShadow: 3 }}
                                />
                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    margin="normal"
                                    label="Capilla"
                                    name="capilla"
                                    value={formData.capilla}
                                    onChange={handleInputChange}
                                    sx={{ boxShadow: 3 }}
                                >
                                    <MenuItem value="CP1">CP1</MenuItem>
                                    <MenuItem value="CC">CC</MenuItem>
                                </TextField>

                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    margin="normal"
                                    label="Lado"
                                    name="lado"
                                    value={formData.lado}
                                    onChange={handleInputChange}
                                    sx={{ boxShadow: 3 }}
                                >
                                    <MenuItem value="A">A</MenuItem>
                                    <MenuItem value="B">B</MenuItem>
                                    <MenuItem value="C">C</MenuItem>
                                    <MenuItem value="D">D</MenuItem>
                                </TextField>

                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    margin="normal"
                                    label="Tipo de Nicho"
                                    name="tipo_nicho"
                                    value={formData.tipo_nicho}
                                    onChange={handleInputChange}
                                    sx={{ boxShadow: 3 }}
                                >
                                    <MenuItem value="doble">Doble</MenuItem>
                                    <MenuItem value="sencillo">Sencillo</MenuItem>
                                </TextField>

                                <TextField
                                    fullWidth
                                    size="small"
                                    margin="normal"
                                    label="Fila / Rango"
                                    name="fila_rango"
                                    value={formData.fila_rango}
                                    onChange={handleInputChange}
                                    helperText="Ejemplo: A-M o A,B,C"
                                    sx={{ boxShadow: 3 }}
                                />
                            </>
                        )}
                        {formData.tipo_servicio === "nicho_ataud" && (
                            <>
                                <TextField
                                    fullWidth
                                    size="small"
                                    margin="normal"
                                    label="Nombre del Plan"
                                    name="descripcion"
                                    value={formData.descripcion}
                                    onChange={handleInputChange}
                                    sx={{ boxShadow: 3 }}
                                />
                            </>
                        )}
                        <TextField
                            fullWidth
                            size="small"
                            margin="normal"
                            label="Precio Contado (BCV)"
                            name="de_contado_bcv"
                            type="number"
                            value={formData.de_contado_bcv}
                            onChange={handleInputChange}
                            sx={{ boxShadow: 3 }}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            size="small"
                            label="Precio Contado ($)"
                            name="de_contado"
                            type="number"
                            value={formData.de_contado}
                            onChange={handleInputChange}
                            sx={{ boxShadow: 3 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip
                                            title="Calcula automáticamente las cuotas habilitadas"
                                            arrow
                                            placement="top"
                                        >
                                            <IconButton size="small" edge="end">
                                                <HelpOutlineIcon fontSize="small" color="action" />
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Typography variant="h6" sx={{ fontFamily: "Bakbak One", color: "#0A4575", mt: 2, mb: 2 }}>Configuración de Cuotas</Typography>

                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                            <Checkbox checked={enabledCuotas.cuota_1} onChange={handleCheckboxChange} name="cuota_1" />
                            <TextField
                                fullWidth size="small" label="3 Cuotas (10%)" name="cuota_1" type="number"
                                value={formData.cuota_1} onChange={handleInputChange}
                                disabled={!enabledCuotas.cuota_1}
                                sx={{ boxShadow: 3 }}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                            <Checkbox checked={enabledCuotas.cuota_2} onChange={handleCheckboxChange} name="cuota_2" />
                            <TextField
                                fullWidth size="small" label="6 Cuotas (20%)" name="cuota_2" type="number"
                                value={formData.cuota_2} onChange={handleInputChange}
                                disabled={!enabledCuotas.cuota_2}
                                sx={{ boxShadow: 3 }}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                            <Checkbox checked={enabledCuotas.cuota_3} onChange={handleCheckboxChange} name="cuota_3" />
                            <TextField
                                fullWidth size="small" label="9 Cuotas (30%)" name="cuota_3" type="number"
                                value={formData.cuota_3} onChange={handleInputChange}
                                disabled={!enabledCuotas.cuota_3}
                                sx={{ boxShadow: 3 }}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                            <Checkbox checked={enabledCuotas.cuota_4} onChange={handleCheckboxChange} name="cuota_4" />
                            <TextField
                                fullWidth size="small" label="12 Cuotas (40%)" name="cuota_4" type="number"
                                value={formData.cuota_4} onChange={handleInputChange}
                                disabled={!enabledCuotas.cuota_4}
                                sx={{ boxShadow: 3 }}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                            <Checkbox checked={enabledCuotas.cuota_5} onChange={handleCheckboxChange} name="cuota_5" />
                            <TextField
                                fullWidth size="small" label="18 Cuotas (60%)" name="cuota_5" type="number"
                                value={formData.cuota_5} onChange={handleInputChange}
                                disabled={!enabledCuotas.cuota_5}
                                sx={{ boxShadow: 3 }}
                            />
                        </div>


                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                            <Button onClick={handleCloseModal} sx={{ mr: 2 }}>Cancelar</Button>
                            <Button variant="contained" onClick={handleSubmit}>Guardar</Button>
                        </Box>
                    </Paper>
                </div>
            )}
        </Box>
    );
};

export default PlanesProductos;